import { render, staticRenderFns } from "./MeasurementUnitForm.vue?vue&type=template&id=a9b710de&scoped=true"
import script from "./MeasurementUnitForm.vue?vue&type=script&lang=js"
export * from "./MeasurementUnitForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b710de",
  null
  
)

export default component.exports